exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".templates-admin__container {\n  padding-top: 3%;\n}\n.templates-admin__container form {\n  padding-top: 3%;\n}\n", ""]);
